export const AFRIPODS_SESSION_ID = 'AFRIPODS_SESSION_ID'
export const DEVICE_ID = 'AFRIPODS_DEVICE_ID'
export const ABTEST_ID = 'AFRIPODS_ABTEST_ID'



// WEBPACK FOOTER //
// ./src/utils/Statistics/Constants.js